import EventsHistory from './EventsHistory';
export default EventsHistory;
